import { Injectable } from '@angular/core';
import { OclOptionsService } from '../../../ocl/services/ocl-options-service/ocl-options.service';

@Injectable({
  providedIn: 'root',
})
export class OccOptionsService extends OclOptionsService {
  // tslint:disable-next-line:variable-name
  protected ParseOptions = Parse.Object.extend('OCCOptions');
}
